// extracted by mini-css-extract-plugin
export default {"colorlib_icon":"ContactSection_colorlib_icon__AiRoI","contact":"ContactSection_contact__NOAu6"};